export const pricingPlans = [
  {
    buttonType: "regular-pricing-btn",
    bloodState: false,
    planType: "AI developing",
    price: 30,
    list: [
      // "Aida dere",
      // "Nec feugiat nisl",
      // "Nulla at volutpat dola",
      // "Pharetra massa",
      // "Massa ultricies mi",
    ],
  },
  {
    buttonType: "green-pricing-btn",
    bloodState: true,
    planType: "3D designing",
    price: 15,
    list: [
      // "Aida dere",
      // "Nec feugiat nisl",
      // "Nulla at volutpat dola",
      // "Pharetra massa",
      // "Massa ultricies mi",
    ],
  },
  {
    buttonType: "regular-pricing-btn",
    bloodState: false,
    planType: "Web or Mobile developing",
    price: 30,
    list: [
      // "Aida dere",
      // "Nec feugiat nisl",
      // "Nulla at volutpat dola",
      // "Pharetra massa",
      // "Massa ultricies mi",
    ],
  },
];
